// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex'

import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader
import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader
import Functions from "@/utils/functions.js";

import Toast from './plugins/toast.js';
import Confirm from './plugins/confirm.js';

import '@/assets/css/style.css'


// Vuetify
Vue.use(Vuetify, {
  iconfont: 'md'
})

Vue.config.productionTip = false

// Functions
Vue.prototype.$functions = Functions;

// Plugins
Vue.use(Toast)
Vue.use(Confirm)


const init = () => {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
};

// Wait for the deviceready event to start the render
document.addEventListener("deviceready", () => {
  init();
});

// If we are not in Cordova, manually trigger the deviceready event
if (!window.cordova) {
  document.dispatchEvent(new CustomEvent("deviceready", {}));
}